module.exports = __webpack_public_path__ + "media/images/proof_links/ivi-b93ac5dff6791bdd985a752191adb74f.svg";